import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export interface TechnicianProviderOption {
  technician_provider_uuid: string | null;
  name: string;
}

export interface TechnicianAutocompleteResult {
  technician_uuid: string; 
  first_name: string;
  last_name: string;
  email: string | null;
  phone: string | null;
  timezone: string | null;
  city: string | null;
  region: string | null;
  country: string | null;
  technician_provider_uuid: string | null;
  technician_provider_name: string;
}
export type TechnicianWithoutUuid = Omit<TechnicianAutocompleteResult, 'technician_uuid'>;

@Injectable({
  providedIn: 'root'
})
export class SearchOrAddTechnicianService {

  constructor(private http: HttpClient) { }

  search(name_type: string, query: string): Observable<TechnicianAutocompleteResult[]>{
    if (!query || query.length < 2) return of([]);
    const url = `/api/contacts/technicians.php?action=all_technicians&filter_type=${encodeURIComponent(name_type)}&filter_query=${encodeURIComponent(query)}`;
    return this.http.get<TechnicianAutocompleteResult[]>(url).pipe(
      map (response => response || [])
    )
  }

  searchProviders(query: string): Observable<TechnicianProviderOption[]>{
    if (!query || query.length < 2){
      return of([]);
    } 
    const url = `/api/contacts/technicians.php?action=all_technician_providers&filter_query=${encodeURIComponent(query)}`;
    return this.http.get<TechnicianProviderOption[]>(url).pipe(map(response => response || []));
  }

  updateLadingSiteCheckTechnician(ladingUuid: string, technicianUuid: string){
    const url = `/api/contacts/technicians.php`;
    console.log(`lading uuid: ${ladingUuid} | technicianUuid: ${technicianUuid}`)
    return this.http.post<ApiPostResponse>(url, {
      lading_uuid: ladingUuid,
      technician_uuid: technicianUuid,
      action: 'update_lading'
    });
  }

  addNewTechnician(data: TechnicianWithoutUuid, action: 'add_technician_only' | 'add_technician_update_lading'){
    const url = `/api/contacts/technicians.php`;
    const postBody = {
      ...data,
      action: action
    };
    return this.http.post<ApiPostResponse>(url, postBody);
  }
}

export interface ApiPostResponse {
  success: boolean;
  file: string;
  code: number;
  message: string;
}
